const variables = {
  settings: {
    theme: 'dark' as Theme,
  },
};

export default variables;
